import type { RevokeInvitationCommand } from "../model/Invitation";
import type { AccountManagementService } from "../port/AccountManagementService";

export class RevokeInvitation {
  constructor(private readonly service: AccountManagementService) {}

  execute(
    command: RevokeInvitationCommand,
    signal?: AbortSignal,
  ): Promise<void> {
    return this.service.revokeInvitation(command, signal);
  }
}
